import React from 'react';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { FaFacebook, FaGoogle } from 'react-icons/fa';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import withQuery from 'with-query';

const FB_COLOR = '#4267B2';
const GOOGLE_COLOR = '#4285F4';

const Styles = styled.div`
  text-align: center;

  button {
    margin: 0.3rem 0;
    width: 100%;
    max-width: 300px;
    border: none;
    padding: 0.3rem;
  }
`;

interface Props {
  from?: string;
}

const ThirdPartyLoginButtons: React.FC<Props> = ({ from }) => {
  const useDevCallback = window.location.href.includes(
    'dev.datalouder.com:3000'
  );

  const fbRedirectUrl = useDevCallback
    ? 'https://dev.datalouder.com:3000/landing/fb'
    : 'https://datalouder.com/landing/fb';

  const fbButtonUrl = withQuery('https://www.facebook.com/v16.0/dialog/oauth', {
    client_id: '144682848546284',
    redirect_uri: fbRedirectUrl,
    scope: 'public_profile,email',
    response_type: 'token',
    state: JSON.stringify({ from }),
  });

  const googleRedirectUrl = useDevCallback
    ? 'https://dev.datalouder.com:3000/landing/google'
    : 'https://datalouder.com/landing/google';

  const googleButtonUrl = withQuery(
    'https://accounts.google.com/o/oauth2/v2/auth/identifier',
    {
      client_id:
        '311012158250-7ta2kmei2i1le9upsu5h3595ff3qfje7.apps.googleusercontent.com',
      redirect_uri: googleRedirectUrl,
      scope: 'profile email',
      response_type: 'id_token',
      nonce: uuidv4(),
      state: JSON.stringify({ from }),
    }
  );

  const { t } = useTranslation();

  return (
    <Styles>
      <div>
        <a href={fbButtonUrl} target="_blank" rel="noreferrer">
          <Button style={{ backgroundColor: FB_COLOR }}>
            <FaFacebook /> {t('continue-with-fb')}
          </Button>
        </a>
      </div>
      <div>
        <a href={googleButtonUrl} target="_blank" rel="noreferrer">
          <Button style={{ backgroundColor: GOOGLE_COLOR }}>
            <FaGoogle /> {t('continue-with-google')}
          </Button>
        </a>
      </div>
    </Styles>
  );
};

export default ThirdPartyLoginButtons;
